import { useEffect, useState } from 'react';

import {
    Box, Button, FormControl, FormLabel, Input, Select, Stack, Textarea, useToast,
} from '@chakra-ui/react';

import { supabase } from '../lib/supabase';

export default function FraudReport() {
  const [accountNumber, setAccountNumber] = useState("");
  const [accountType, setAccountType] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [institutionName, setInstitutionName] = useState("");
  const [fraudType, setFraudType] = useState("");
  const [description, setDescription] = useState("");
  const [banks, setBanks] = useState<
    { bank_code: string; bank_name: string }[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    async function fetchBanks() {
      const { data, error } = await supabase
        .from("bank_list")
        .select("bank_code, bank_name");
      if (error) {
        console.error("Error fetching banks:", error);
      } else {
        setBanks(data || []);
      }
    }
    fetchBanks();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // TODO: Implement fraud report submission
      toast({
        title: "Success",
        description: "Fraud report submitted successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Error",
        description:
          error instanceof Error ? error.message : "Failed to submit report",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt={8} p={6}>
      <form onSubmit={handleSubmit}>
        <Stack spacing={4}>
          <FormControl isRequired>
            <FormLabel>Account Number</FormLabel>
            <Input
              type="text"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Account Type</FormLabel>
            <Select
              value={accountType}
              onChange={(e) => setAccountType(e.target.value)}
              placeholder="Select account type"
            >
              <option value="bank">Bank Account</option>
              <option value="ewallet">E-Wallet</option>
              <option value="crypto">Crypto Address</option>
            </Select>
          </FormControl>

          {accountType === "bank" ? (
            <FormControl isRequired>
              <FormLabel>Bank</FormLabel>
              <Select
                value={bankCode}
                onChange={(e) => setBankCode(e.target.value)}
                placeholder="Select a bank"
              >
                {banks.map((bank) => (
                  <option key={bank.bank_code} value={bank.bank_code}>
                    {bank.bank_name}
                  </option>
                ))}
              </Select>
            </FormControl>
          ) : (
            <FormControl isRequired>
              <FormLabel>Institution Name</FormLabel>
              <Input
                type="text"
                value={institutionName}
                onChange={(e) => setInstitutionName(e.target.value)}
                placeholder="Enter institution name"
              />
            </FormControl>
          )}

          <FormControl isRequired>
            <FormLabel>Type of Fraud</FormLabel>
            <Select
              value={fraudType}
              onChange={(e) => setFraudType(e.target.value)}
              placeholder="Select fraud type"
            >
              <option value="unauthorized_transaction">
                Unauthorized Transaction
              </option>
              <option value="identity_theft">Identity Theft</option>
              <option value="phishing">Phishing</option>
              <option value="other">Other</option>
            </Select>
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Description</FormLabel>
            <Textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Please provide details about the fraud incident..."
            />
          </FormControl>

          <Button
            type="submit"
            colorScheme="blue"
            isLoading={isLoading}
            width="full"
          >
            Submit Report
          </Button>
        </Stack>
      </form>
    </Box>
  );
}
